/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { DocumentNode } from 'graphql';
import carOperations from './car';
import configurationOperations from './configuration';
import customerOperations from './customer';
import insuranceOperations from './insurance';
import navigationOperations from './navigation';
import proceduresOperations from './procedures';
import termsAndConditionsOperations from './termsAndConditions';
import userOperations from './user';
import purchaseIntentOperations from './purchaseIntent';

const operations: { [key: string]: DocumentNode } = {
  ...carOperations,
  ...configurationOperations,
  ...customerOperations,
  ...insuranceOperations,
  ...navigationOperations,
  ...proceduresOperations,
  ...termsAndConditionsOperations,
  ...userOperations,
  ...purchaseIntentOperations,
};

export default operations;
